// extracted by mini-css-extract-plugin
export default {"asideContainer":"styles_asideContainer__btn8v"};